import { render, staticRenderFns } from "./SupplierVerification.vue?vue&type=template&id=18e26df0&"
import script from "./SupplierVerification.vue?vue&type=script&lang=js&"
export * from "./SupplierVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports